import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import FlagOutlined from '@material-ui/icons/FlagOutlined'

/**
 * Watch-orange flag with its reason in a tooltip. The wrapper is focusable and carries the label, so keyboard and
 * screen reader users get the reason too; the icon itself is decorative.
 */
const FlagIcon = ({ title, style, fontSize = 'small' }) => (
    <Tooltip title={title} placement='top' arrow>
        <span tabIndex={0} role='img' aria-label={title}
            style={{ display: 'inline-flex', flexShrink: 0, color: 'var(--badge-watch-ink)', cursor: 'help', ...style }}>
            <FlagOutlined fontSize={fontSize} aria-hidden='true' />
        </span>
    </Tooltip>
)

export default FlagIcon
